var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('RouteListItem',{attrs:{"node":{
      name: _vm.node.name,
      meta: {
        displayName: _vm.$t('servicesystem.pages.page_titles.job_my_jobs'),
        icon: 'mdi-briefcase-account',
        count: 0,
        params: { filter: 'my' }
      }
    }}}),_c('RouteListItem',{attrs:{"node":{
      name: _vm.node.name,
      meta: {
        displayName: _vm.$t('servicesystem.pages.page_titles.job_parts_jobs'),
        icon: 'mdi-fridge-alert',
        count: 0,
        params: { filter: 'parts' }
      }
    }}}),(_vm.StatusLoading)?_c('v-progress-linear',{attrs:{"indeterminate":"","height":"1"}}):_c('v-divider',{staticStyle:{"border-color":"rgb(151 151 151 / 12%)"}}),_vm._l((_vm.StatusList),function(status,index){return _c('StatusRouteListItem',{key:index,attrs:{"status":status,"node":_vm.node}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }